/**
 * Entry/Exit Reason Service
 *
 * API calls for entry/exit reason management
 */

import api from '../utils/api';
import config from '../config';

const entryExitReasonService = {
  /**
   * Get initialization data for entry/exit reason form (Entry Exit Statuses dropdown)
   * @returns {Promise} Response data with initialization data
   */
  getInit: async () => {
    return api.get(config.endpoints.entryExitReasons.init);
  },

  /**
   * Get list of entry/exit reasons
   * @param {Object} params - Query parameters (page, pageSize, filters)
   * @returns {Promise} Response data with entry/exit reasons list
   */
  getEntryExitReasons: async (params = {}) => {
    return api.get(config.endpoints.entryExitReasons.list, params);
  },

  /**
   * Get entry/exit reason by ID
   * @param {number} id - Entry/Exit Reason ID
   * @returns {Promise} Response data with entry/exit reason details
   */
  getEntryExitReasonById: async (id) => {
    return api.get(`${config.endpoints.entryExitReasons.getById}/${id}`);
  },

  /**
   * Create new entry/exit reason
   * @param {Object} entryExitReasonData - Entry/Exit Reason data
   * @returns {Promise} Response data with created entry/exit reason
   */
  createEntryExitReason: async (entryExitReasonData) => {
    return api.post(config.endpoints.entryExitReasons.create, entryExitReasonData);
  },

  /**
   * Update entry/exit reason
   * @param {number} id - Entry/Exit Reason ID
   * @param {Object} entryExitReasonData - Updated entry/exit reason data
   * @returns {Promise} Response data with updated entry/exit reason
   */
  updateEntryExitReason: async (id, entryExitReasonData) => {
    return api.put(`${config.endpoints.entryExitReasons.update}/${id}`, entryExitReasonData);
  },

  /**
   * Delete entry/exit reason
   * @param {number} id - Entry/Exit Reason ID
   * @returns {Promise} Response data
   */
  deleteEntryExitReason: async (id) => {
    return api.delete(`${config.endpoints.entryExitReasons.delete}/${id}`);
  },

  /**
   * Bulk delete entry/exit reasons
   * @param {Array<number>} ids - Array of entry/exit reason IDs
   * @returns {Promise} Response data
   */
  bulkDeleteEntryExitReasons: async (ids) => {
    return api.post(config.endpoints.entryExitReasons.bulkDelete, { ids });
  },
};

export default entryExitReasonService;
